const reoccuringText = {
    multipleColumnInRowWarningText: "Forms with multiple columns per row will be displayed as a single column on mobile devices for optimal viewing."
}

export default reoccuringText